export default __webpack_public_path__ + "static/media/team-mosaic-03.a684aa41.jpg";